import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../images/Logo.png';
import DestinationImage from '../images/DestinationImage.jpg';
import MapImage from '../images/MapImage.jpg';
import '../styles/template.css';

const FORMSPREE_ENDPOINT = 'https://formspree.io/f/xojprvry';

const FeaturedDestinationsPage = () => {
  const [formData, setFormData] = useState({
    businessName: '',
    location: '',
    website: '',
    businessCategory: '',
    otherCategory: '',
    goals: '',
    contactMethod: 'email',
    contact: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);

  const allCategories = [
    { group: 'Other', categories: [
      { name: 'Other (please specify)', id: 999 },
    ]},
    { group: 'Fitness & Sports', categories: [
      { name: 'Weight Lifting Gyms', id: 100 },
      { name: 'MMA Gyms', id: 101 },
      { name: 'Billiards / Pool Halls', id: 102 },
      { name: 'Basketball Courts', id: 103 },
      { name: 'Golf Courses', id: 104 },
      { name: 'Tennis Courts', id: 105 },
      { name: 'Soccer Fields', id: 106 },
    ]},
    { group: 'Music & Performance', categories: [
      { name: 'Jazz Lounges', id: 300 },
      { name: 'Record Stores', id: 301 },
      { name: 'Instrument Stores', id: 302 },
      { name: 'Music Schools', id: 303 },
      { name: 'Concert Venues', id: 304 },
    ]},
    { group: 'Nature & Outdoors', categories: [
      { name: 'Scenic Views', id: 400 },
      { name: 'National Parks', id: 401 },
      { name: 'Hiking Trails', id: 402 },
      { name: 'Community Gardens', id: 403 },
      { name: 'Outdoor Retailers', id: 405 },
    ]},
    { group: 'Books & Culture', categories: [
      { name: 'Libraries', id: 500 },
      { name: 'History Museums', id: 501 },
      { name: 'Comedy Clubs', id: 502 },
      { name: 'Poetry and Spoken Word', id: 503 },
      { name: 'Literary Arts Venues', id: 504 },
    ]},
    { group: 'Wellness & Mindfulness', categories: [
      { name: 'Meditation Centers', id: 600 },
      { name: 'Yoga Studios', id: 601 },
      { name: 'Chess Clubs', id: 603 },
      { name: 'Float Tank Therapy', id: 604 },
    ]},
    { group: 'Art & Creativity', categories: [
      { name: 'Art Museums', id: 700 },
      { name: 'Home Design Studios', id: 701 },
      { name: 'Pottery Studios', id: 702 },
      { name: 'Woodworking Shops', id: 703 },
      { name: 'Art Studios', id: 704 },
    ]},
    { group: 'Social & Community', categories: [
      { name: 'Board Games', id: 800 },
      { name: 'Dance Clubs', id: 801 },
      { name: 'Recreation Centers', id: 802 },
      { name: 'Volunteer Organizations', id: 803 },
      { name: 'Co-Working Spaces', id: 804 },
    ]},
    { group: 'Learning & Science', categories: [
      { name: 'Research Laboratories', id: 200 },
      { name: 'Aviation Museums', id: 201 },
      { name: 'Gaming and Arcades', id: 202 },
      { name: 'Science and Space Centers', id: 203 },
    ]},
  ];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setShowError(false);
    setShowSuccess(false);

    let selectedCategoryLabel = 'Not selected';
    for (const group of allCategories) {
      const found = group.categories.find(
        (c) => c.id === parseInt(formData.businessCategory)
      );
      if (found) {
        selectedCategoryLabel = found.id === 999
          ? `Other: ${formData.otherCategory}`
          : `${found.name} (${group.group})`;
        break;
      }
    }

    try {
      const response = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          'Business Name': formData.businessName,
          'Location': formData.location,
          'Website': formData.website || 'Not provided',
          'Business Category': selectedCategoryLabel,
          'Partnership Goals': formData.goals || 'Not provided',
          'Preferred Contact Method': formData.contactMethod,
          'Contact Details': formData.contact
        })
      });

      if (!response.ok) throw new Error('Submission failed');

      setShowSuccess(true);
      setFormData({
        businessName: '', location: '', website: '',
        businessCategory: '', otherCategory: '', goals: '',
        contactMethod: 'email', contact: ''
      });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err) {
      setShowError(true);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className='container'>
      <header>
        <div className='logo-container'>
          <img src={Logo} alt='Logo' className='logo' />
        </div>
        <h1>Get Featured</h1>
        <nav>
          <ul>
            <li><Link to='/'>Home</Link></li>
            <li><Link to='/about'>About</Link></li>
            <li><Link to='/partners'>Partners</Link></li>
            <li><Link to='/destinations'>Get Featured</Link></li>
            <li><Link to='/connect'>Meetups</Link></li>
            <li><Link to='/contact'>Contact Us</Link></li>
          </ul>
        </nav>
      </header>

      <main>
        <h2 className='main-heading'>Become a Featured Destination</h2>

        {showSuccess && (
          <div style={{
            backgroundColor: '#d4edda',
            border: '2px solid #28a745',
            borderRadius: '8px',
            padding: '24px',
            marginBottom: '24px',
            color: '#155724'
          }}>
            <h3 style={{ marginBottom: '12px', fontSize: '18px' }}>
              Application Received!
            </h3>
            <p>
              Thanks for applying to become a featured destination on Know Yourself.
              We'll review your application and be in touch within 2 business days.
            </p>
          </div>
        )}

        {showError && (
          <div style={{
            backgroundColor: '#f8d7da',
            border: '2px solid #dc3545',
            borderRadius: '8px',
            padding: '24px',
            marginBottom: '24px',
            color: '#721c24'
          }}>
            <h3 style={{ marginBottom: '12px', fontSize: '18px' }}>
              Something went wrong.
            </h3>
            <p>
              Please try again or reach out to us directly at{' '}
              <a
                href='mailto:support@know-yourself-project.com'
                style={{ color: '#721c24', fontWeight: '600' }}
              >
                support@know-yourself-project.com
              </a>
            </p>
          </div>
        )}

        {/* ── Intro ───────────────────────────────────────────── */}
        <section className='partners-intro'>
          <p>
            Know Yourself connects people with places that match who they actually are —
            not just what's nearby. Our users aren't casual browsers. They're people who
            take their interests seriously and are actively looking for places like yours.
          </p>
          <p style={{ marginTop: '16px' }}>
            As a Featured Destination, your business gets in front of the right people
            at the right time — matched by interest, not just location.
          </p>
        </section>

        {/* ── App preview ─────────────────────────────────────── */}
        <section style={{ marginTop: '40px' }}>
          <h3>See It in Action</h3>
          <p style={{ color: '#666', marginBottom: '24px' }}>
            Here's exactly where your business shows up inside the Know Yourself app.
          </p>
          <div style={{
            display: 'flex',
            gap: '20px',
            flexWrap: 'wrap',
            marginTop: '16px'
          }}>
            <div style={{ flex: '1', minWidth: '260px' }}>
              <img
                src={MapImage}
                alt='Know Yourself interactive map'
                style={{
                  width: '100%',
                  borderRadius: '8px',
                  border: '1px solid #ddd'
                }}
              />
              <p style={{ fontSize: '14px', color: '#666', marginTop: '8px' }}>
                Featured destinations appear prominently on the interactive map
              </p>
            </div>
            <div style={{ flex: '1', minWidth: '260px' }}>
              <img
                src={DestinationImage}
                alt='Destination profile in Know Yourself app'
                style={{
                  width: '100%',
                  borderRadius: '8px',
                  border: '1px solid #ddd'
                }}
              />
              <p style={{ fontSize: '14px', color: '#666', marginTop: '8px' }}>
                Each featured destination gets its own profile inside the app
              </p>
            </div>
          </div>
        </section>

        {/* ── Benefits ────────────────────────────────────────── */}
        <section className='partnership-benefits'
          style={{ marginTop: '40px', marginBottom: '40px' }}>
          <h3>What You Get</h3>
          <div className='benefit-list' style={{ marginTop: '20px' }}>
            <div style={{ marginBottom: '16px' }}>
              <strong>📍 Map Visibility</strong>
              <p>Your business appears prominently on our interactive map
              with a special featured designation that sets you apart.</p>
            </div>
            <div style={{ marginBottom: '16px' }}>
              <strong>🔔 Targeted Notifications</strong>
              <p>We send personalized push notifications to users whose
              interests align with your business — not mass blasts, real matches.</p>
            </div>
            <div style={{ marginBottom: '16px' }}>
              <strong>📊 Website Traffic Tracking</strong>
              <p>See exactly how many users we send to your website
              through your own Google Analytics.</p>
            </div>
            <div style={{ marginBottom: '16px' }}>
              <strong>🎯 Qualified Leads</strong>
              <p>Reach customers who are genuinely interested in what
              you offer — not random traffic that bounces.</p>
            </div>
            <div style={{ marginBottom: '16px' }}>
              <strong>📸 Instagram Feature</strong>
              <p>We spotlight featured destinations on the Know Yourself
              Instagram — putting your business in front of our community
              with a dedicated post.</p>
            </div>
          </div>
        </section>

        {/* ── Application form ────────────────────────────────── */}
        <section className='partnership-form' style={{ marginTop: '60px' }}>
          <h3>Apply Now</h3>
          <p style={{ marginBottom: '30px', color: '#666' }}>
            Fill out the form below and we'll be in touch within 2 business days.
          </p>
          <form onSubmit={handleSubmit}
            style={{ maxWidth: '600px', margin: '0 auto' }}>

            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                Business Name *
              </label>
              <input
                type='text'
                name='businessName'
                value={formData.businessName}
                onChange={handleChange}
                required
                style={{
                  width: '100%', padding: '12px',
                  border: '1px solid #ddd', borderRadius: '4px',
                  fontSize: '16px'
                }}
              />
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                Location *
              </label>
              <input
                type='text'
                name='location'
                value={formData.location}
                onChange={handleChange}
                placeholder='e.g., Los Angeles, CA'
                required
                style={{
                  width: '100%', padding: '12px',
                  border: '1px solid #ddd', borderRadius: '4px',
                  fontSize: '16px'
                }}
              />
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                Website{' '}
                <span style={{ color: '#666', fontWeight: 'normal' }}>(optional)</span>
              </label>
              <input
                type='url'
                name='website'
                value={formData.website}
                onChange={handleChange}
                placeholder='https://yourwebsite.com'
                style={{
                  width: '100%', padding: '12px',
                  border: '1px solid #ddd', borderRadius: '4px',
                  fontSize: '16px'
                }}
              />
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                Business Type *
              </label>
              <select
                name='businessCategory'
                value={formData.businessCategory}
                onChange={handleChange}
                required
                style={{
                  width: '100%', padding: '12px',
                  border: '1px solid #ddd', borderRadius: '4px',
                  fontSize: '16px'
                }}
              >
                <option value=''>
                  Select the category that best fits your business...
                </option>
                {allCategories.map((group) => (
                  <optgroup key={group.group} label={group.group}>
                    {group.categories.map((category) => (
                      <option key={category.id} value={category.id}>
                        {category.name}
                      </option>
                    ))}
                  </optgroup>
                ))}
              </select>
              <small style={{ display: 'block', marginTop: '4px', color: '#666' }}>
                Don't see your business type? Select Other above and tell us more.
              </small>
            </div>

            {String(formData.businessCategory) === '999' && (
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                  Please describe your business type *
                </label>
                <input
                  type='text'
                  name='otherCategory'
                  value={formData.otherCategory}
                  onChange={handleChange}
                  placeholder='e.g., Escape Room, Axe Throwing...'
                  required
                  style={{
                    width: '100%', padding: '12px',
                    border: '1px solid #ddd', borderRadius: '4px',
                    fontSize: '16px'
                  }}
                />
              </div>
            )}

            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                What are you hoping to achieve?{' '}
                <span style={{ color: '#666', fontWeight: 'normal' }}>(optional)</span>
              </label>
              <textarea
                name='goals'
                value={formData.goals}
                onChange={handleChange}
                placeholder='More foot traffic, brand awareness, reaching a specific type of customer...'
                rows='4'
                style={{
                  width: '100%', padding: '12px',
                  border: '1px solid #ddd', borderRadius: '4px',
                  fontSize: '16px', resize: 'vertical'
                }}
              />
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                Preferred Contact Method *
              </label>
              <select
                name='contactMethod'
                value={formData.contactMethod}
                onChange={handleChange}
                required
                style={{
                  width: '100%', padding: '12px',
                  border: '1px solid #ddd', borderRadius: '4px',
                  fontSize: '16px'
                }}
              >
                <option value='email'>Email</option>
                <option value='phone'>Phone</option>
              </select>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                Contact Details *
              </label>
              <input
                type='text'
                name='contact'
                value={formData.contact}
                onChange={handleChange}
                placeholder='Email address or phone number'
                required
                style={{
                  width: '100%', padding: '12px',
                  border: '1px solid #ddd', borderRadius: '4px',
                  fontSize: '16px'
                }}
              />
            </div>

            <button
              type='submit'
              className='cta-button'
              disabled={isSubmitting}
              style={{
                width: '100%',
                padding: '16px',
                marginTop: '10px',
                opacity: isSubmitting ? 0.7 : 1,
                cursor: isSubmitting ? 'not-allowed' : 'pointer'
              }}
            >
              {isSubmitting ? 'Submitting...' : 'Submit Application'}
            </button>

          </form>
        </section>
      </main>

      <footer>
        <p>&copy; 2026 Know Yourself LLC | All rights reserved.</p>
      </footer>
    </div>
  );
};

export default FeaturedDestinationsPage;
